import { useContext, useEffect, useState } from "react"
import { AuthenticationContext, AzureProviderContext } from "stores"
import { IdleTimer } from "components/helpers"
import { signOutApi, useRefreshToken } from "queries"

const AuthBlock = () => {
  const [timeoutMinutes, setTimeoutMinutes] = useState<number>(2)
  const { isAuthorized, storeAuthToken, secondsLeft, setSecondsLeft, signOut } =
    useContext(AuthenticationContext)
  const azureContext = useContext(AzureProviderContext)

  const token = useRefreshToken(isAuthorized)

  useEffect(() => {
    if (isAuthorized) {
      if (!token.isLoading) {
        if (
          token.data &&
          !token.isError &&
          token.data.validationResult.isValid
        ) {
          storeAuthToken(token.data.data.idToken, token.data.data.expiresIn)
        } else {
          if (azureContext && azureContext.authProvider)
            azureContext.authProvider.logout()
          signOut()
        }
      }
    }
  }, [token.data, token.isLoading])

  useEffect(() => {
    if (isAuthorized && token.data && !token.isError) {
      const ideal = token.data.data?.idealTimeOutInMinutes
      if (typeof ideal === "number" && ideal > 0) {
        setTimeoutMinutes(ideal)
      } else {
        setTimeoutMinutes(10)
      }
    }
  }, [isAuthorized, token.data, token.isError])

  useEffect(() => {
    const timerId = setTimeout(() => {
      setSecondsLeft(secondsLeft - 60)
      if (isAuthorized) {
        if (secondsLeft < 61) {
          token.refetch()
        }
      }
    }, 60000)

    return () => {
      clearTimeout(timerId)
    }
  }, [isAuthorized, secondsLeft, setSecondsLeft, storeAuthToken])

  useEffect(() => {
    let timer
    if (isAuthorized) {
      timer = new IdleTimer({
        timeout: timeoutMinutes * 60,
        onTimeout: async () => {
          await signOutApi()
          if (azureContext && azureContext.authProvider)
            azureContext.authProvider.logout()
          signOut()
        },
      })
    }

    return () => timer && timer.cleanUp()
    // recreate timer when authorization or timeoutMinutes changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized, timeoutMinutes])

  return null
}

export default AuthBlock
